import saveAs from 'file-saver';

import { NewsResponse } from '../types';
import {
  DashboardClause,
  DefaultOrganizationsRecapResponse,
  PratiquesSynthesisResponse,
} from '../types/stats';

import {
  FORM_STATUS,
  handleRequest,
  privateClient,
} from '@data-access';

const formatOrganizationFilter = (
  organizationIds: number[] = [],
): Record<string, string> => {
  if (organizationIds.length === 0) {
    return { organization: '' };
  }

  return {
    organization: organizationIds.join(','),
  };
};

const formatOwnerFilter = (
  ownerIds: number[] | null,
): Record<string, string> => {
  if (ownerIds === null) {
    return {};
  }

  if (ownerIds.length === 0) {
    return { owner: '' };
  }

  return {
    owner: ownerIds.join(','),
  };
};

const formatClauseFilter = (
  clause: DashboardClause,
  campaignYear: number | null,
): Record<string, string> => {
  if (clause === 'new' && campaignYear != null) {
    return {
      clause: 'new',
      campaign_year: String(campaignYear),
    };
  }

  return { clause: 'gp' };
};

export const dashboardApi = {
  news: async () => {
    return handleRequest<NewsResponse>(privateClient.get('news/').json());
  },
  getPratiquesSynthesis: async (
    organizationIds: number[] = [],
    ownerIds: number[] | null = null,
    clause: DashboardClause = 'gp',
    campaignYear: number | null = null,
  ) => {
    return handleRequest<PratiquesSynthesisResponse>(
      privateClient
        .get('pratiques_synthesis/', {
          searchParams: {
            ...formatOrganizationFilter(organizationIds),
            ...formatOwnerFilter(ownerIds),
            ...formatClauseFilter(clause, campaignYear),
          },
        })
        .json(),
    );
  },
  getDefaultOrganizationsRecap: async (
    ownerIds: number[] | null = null,
    clause: DashboardClause = 'gp',
    campaignYear: number | null = null,
  ) => {
    return handleRequest<DefaultOrganizationsRecapResponse>(
      privateClient
        .get('pratiques_synthesis/default_organizations/', {
          searchParams: {
            ...formatOwnerFilter(ownerIds),
            ...formatClauseFilter(clause, campaignYear),
          },
        })
        .json(),
    );
  },
  exportStats: async (organizationIds: number[] = []) => {
    const res = await handleRequest<{
      id: 89;
      status: FORM_STATUS;
      instance_id: 89;
    }>(
      privateClient
        .post('dashboard/admin/prep_synthesis/', {
          searchParams: {
            ...formatOrganizationFilter(organizationIds),
          },
        })
        .json(),
    );

    return res;
  },
  downloadExport: async (opts: { id: number }) => {
    const res = await handleRequest(
      privateClient.post('dashboard/admin/synthesis/', {
        json: {
          instance_id: opts.id,
        },
      }),
    );

    // Extract filename from header
    const filename = res.headers
      .get('content-disposition')
      ?.split(';')
      .find((n) => n.includes('filename='))
      ?.replace('filename=', '')
      .trim();

    const blob = await res.blob();

    saveAs(blob, filename);

    return res;
  },
};
